import MixinOption from './options'
import {getCustomerList} from '@api/account'
import {exportMarketingList, marketingProfessionalList} from '@api/marketing'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import {getPolicyList} from '@api/policy'

export default {
  mixins:[MixinOption,MixinFormat],
  data() {
    return {
      pageConfig: {
        currentPage: 1,
        total: 10
      },
      tableData: [],
    }
  },
  computed: {
    ...mapState('quote', ['carModelOptions']),
    reportUrl(){
      let path = this.$route.path
      let arr = path.split('/')
      let last = arr[arr.length - 1]||''
      return last
    },
    reportType(){
      let last = this.reportUrl
      let obj = {
        'sign-up':1,
        'professional-user':2,
        'client-profile':3,
        'policy-mgm':4,
        'private-car':5,
        'motorcycle':6,
        'travel':7,
        'all-policy':13,
      }
      return obj[last]
    },
    classTypeOptions(){
      return this.globalOptions.class_data.filter(item => item.id != 90) || []
    },
    classOptions(){
      return (index)=>{
        let arr = this.classTypeOptions
        let data = []
        data = index==1? arr.filter(item =>item.id>50&&item.id<80): arr.filter(item =>item.id<50||item.id>80)
        return data
      }
    },
    partnerList(){
      return this.globalOptions.policy_partner_filter || []
    },
    brandList() {
      let {brand=[]}=this.allOptions12||{}
      return brand
    },
    insurerList(){
      let arr = JSON.parse(JSON.stringify(this.insurerAllOptions))
      // arr.unshift({id: 0, name: 'All'})
      return arr
    },
    channelList(){
      return this.specialOptions.source || []
    },
    effeOptions() {
      return this.globalOptions.effectiveness
    },
    policyTagsOptions(){
      let {pcy_tag=[]} = this.globalOptions||{}
      let arr = pcy_tag.filter(item=>item.id==1||item.id==1024)
      return arr||[]
    },
    policyBodyTypeList() {
      let {typ_of_bdy} = this.allOptions||{}
      return typ_of_bdy||{}
    },
    policyStatusOption() {
      return this.globalOptions.new_pcy_stts
    },
    policyPlanTypeList(){
      let {plan_type}= this.allOptions23||{}
      return plan_type||[]
    },
    userStatusOptions(){
      return[{
        name: 'Active',
        id: 1
      },
      {
        name: 'Banned',
        id: 0
      },]
    },
    statusExpiryOptions(){
      return[{
        name: 'Active',
        id: 2
      },
      {
        name: 'Expiry',
        id: 3
      },]
    },
    tagsOptions() {
      return this.globalOptions.pcy_tag
    },
    diff(){
      let res = false
      Object.keys(this.defaultFilter).forEach(key => {
        let vue_data = JSON.parse(JSON.stringify(this[key]))
        let default_data = JSON.parse(JSON.stringify(this.defaultFilter[key]))
        if(Array.isArray(vue_data) && Array.isArray(default_data)){
          vue_data.sort()
          default_data.sort()
        }
        if(JSON.stringify(vue_data) != JSON.stringify(default_data)){
          res =  true
        }
      })
      return res
    },
    isPolicyReport(){
      let name = this.reportUrl
      return ['policy-mgm','private-car','motorcycle','travel'].includes(name)
    },
  },
  watch: {
  },
  mounted() {
    this.filterData()
  },
  methods: {
    exportList(){
      this.network().exportMarketingList()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.getReportList(this.reportUrl)
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.getReportList(this.reportUrl)
    },
    resetFilter(){
      Object.keys(this.defaultFilter).forEach(key => {
        this[key] = this.defaultFilter[key]
      })
      this.filterData()
    },
    getReportList(name){
      switch (name){
        case 'sign-up':
          this.network().getCustomerList()
          break
        case 'client-profile':
          this.network().getCustomerList()
          break
        case 'professional-user':
          this.network().marketingProfessionalList()
          break
        case 'policy-mgm':
          this.network().getPolicyList()
          break
        case 'private-car':
          this.network().getPolicyList()
          break
        case 'motorcycle':
          this.network().getPolicyList()
          break
        case 'travel':
          this.network().getPolicyList()
        case 'all-policy':
          this.network().getPolicyList()
          break
        default:
          break
      }
    },
    handlerSelectAll(target) {
      let origin = ''
      let statusOptions = 'userStatusOptions'
      if(this.reportUrl=='professional-user'){
        statusOptions = 'statusExpiryOptions'
      }
      switch(target) {
        case 'status':
          origin = statusOptions
          break
        case 'stts':
          origin = 'policyStatusOption'
          break
        case 'effe':
          origin = 'effeOptions'
          break
        case 'tags':
          origin = 'policyTagsOptions'
          break
        case 'source':
          origin = 'channelList'
          break
        case 'partner':
          origin = 'partnerList'
        case 'type':
          origin = 'userTypeOptions'
      }
      if(!this.isPolicyReport&&target=='tags'){
        this.tier_base = 1
        this.is_blocked = 1
      }else {
        const data = this[origin].reduce((result, item) => {
          result.push(item.id)
          return result
        }, [])
        this[target] = data
      }
      this.filterData()
    },
    handlerNoneAll(target){
      if(!this.isPolicyReport&&target=='tags'){
        this.tier_base = 0
        this.is_blocked = 0
      }else {
        this[target] = []
      }
      this.filterData()
    },
    network(){
      return{
        getCustomerList: async () => {
          let params = {}
          Object.keys(this.defaultFilter).forEach(key => {
            params[key] = this[key]
          })
          params.created_start=this.date[0]
          params.created_end=this.date[1]
          let {data} = await getCustomerList({
            page: this.pageConfig.currentPage,
            ...params
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getPolicyList: async () => {
          let params = {}
          Object.keys(this.defaultFilter).forEach(key => {
            params[key] = this[key]
          })
          params.created_start = this.date[0]
          params.created_end = this.date[1]
          params.cmnt_dt = this.effective_date[0]
          params.expry_dt = this.effective_date[1]
          const { data } = await getPolicyList(params)
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        marketingProfessionalList: async () => {
          let params = {}
          Object.keys(this.defaultFilter).forEach(key => {
            params[key] = this[key]
          })
          params.created_start=this.date[0]
          params.created_end=this.date[1]
          let {data} = await marketingProfessionalList({
            page: this.pageConfig.currentPage,
            ...params
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        exportMarketingList: async () => {
          let params = {}
          let path = this.$route.path
          let arr = path.split('/')
          let last = arr[arr.length - 1]
          let path_arr = ['policy-mgm','private-car','motorcycle','travel','all-policy']
          if(path_arr.includes(last)){
            params.merchant_platform = 1
          }
          Object.keys(this.defaultFilter).forEach(key => {
            params[key] = this[key]
          })
          params.created_start=this.date[0]
          params.created_end=this.date[1]
          if([4,5,6,7].includes(this.reportType)){
            params.cmnt_dt = this.effective_date[0]
            params.expry_dt = this.effective_date[1]
          }
          params.report_type = this.reportType
          const res = await exportMarketingList(params)
        },
      }
    }
  }
}
